<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="6">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal2(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد پوستر
        </b-button>
      </b-col>
      <!-- <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد اسلایدر
        </b-button>
      </b-col> -->
    </b-row>
    <div v-if="posters">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="postersSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-card body-class="p-0" class="mt-1">
        <table-head
          ref="postersTableHeadComponent"
          :items="tableHeadings"
          @sort="sort"
        />
        <b-row
          class="py-1 mx-1 border-bottom"
          v-for="poster in posters"
          :key="poster.id"
        >
          <b-col class="d-flex align-items-center pl-0">
            <img
              style="border-radius: 15px; width: 100%"
              :src="$http.defaults.fileUrl + poster.desktop_image.path"
            />
          </b-col>
          <b-col
            class="d-flex align-items-center flex-row-reverse"
            style="direction: ltr"
          >
            {{ poster.url }}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            {{ poster.name }}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            {{
              new Date(poster.created_at).toLocaleDateString("fa-IR", {
                timeZone: "Iran",
              })
            }}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            {{ poster.poster == 0 ? "خانه" : "" }}
            {{ poster.poster == 1 ? "الهام بخش برای سفرهای بعدی شما" : "" }}
            {{ poster.poster == 2 ? "اقامت در روم توریان" : "" }}
            {{
              poster.poster == 3
                ? "تورهای فراموش نشدنی که توسط مردم محلی برگزار می شود"
                : ""
            }}
          </b-col>
          <b-col
            class="d-flex align-items-center pl-0"
            :class="poster.poster == 0 ? 'text-danger' : 'text-primary'"
          >
            {{ poster.poster == 0 ? "اسلایدر" : "پوستر" }}
          </b-col>
          <b-col
            class="d-flex align-items-center pl-0"
            :class="poster.status !== 'active' ? 'text-danger' : 'text-success'"
          >
            {{ poster.status == "active" ? "" : "غیر" }}فعال
          </b-col>

          <b-col class="d-flex align-items-center">
            <b-button
              @click="showConfirmModal(poster)"
              variant="flat-danger"
              class="font-weight-bolder"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
            <b-button
              @click="showFormModal2(poster)"
              variant="flat-secondary"
              class="font-weight-bolder"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <pagination
        ref="postersPaginationComponent"
        v-model="page"
        :paginationData="paginationData"
      />
    </div>
    <b-sidebar
      width="500px"
      v-model="formModal2"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal2 = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش پوستر" : "ایجاد پوستر" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-row>
          <b-form-group class="mt-1 col-md-6">
            <label for="city_province" class="text-capitalize"> استان :</label>
            <v-select
              id="city_province"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="posterInput.state_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :reduce="(province) => province.id"
              :options="provinces"
              placeholder="برای جستجو تایپ کنید"
              @input="getSelectedProvincesCity"
            />
            <ErrorMessage errorType="state" :errorMessages="allErrors"></ErrorMessage>
          </b-form-group>
          <b-form-group class="mt-1 col-md-6">
            <label for="city_province" class="text-capitalize"> شهر :</label>
            <v-select
              :loading="showGettingCityLoading"
              id="city_province"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="posterInput.city_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :reduce="(city) => city.id"
              :options="cities"
              placeholder="برای جستجو تایپ کنید"
            />
            <ErrorMessage errorType="city" :errorMessages="allErrors"></ErrorMessage>
          </b-form-group>
        </b-row>
        <b-form-group class="mt-">
          <label for="name" class="text-capitalize">عنوان : </label>
          <b-form-input
            id="name"
            type="text"
            @input="removeErrors('name')"
            v-model="posterInput.name"
          />
          <ErrorMessage errorType="name" :errorMessages="allErrors"></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="name" class="text-capitalize">لینک : </label>
          <b-form-input
            id="name"
            type="text"
            placeholder="https://admin-roomtoor.iran.liara.run/"
            @input="removeErrors('url')"
            v-model="posterInput.url"
          />
          <ErrorMessage errorType="url" :errorMessages="allErrors"></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="slug" class="text-capitalize">slug : </label>
          <b-form-input
            id="slug"
            type="text"
            @input="removeErrors('slug')"
            v-model="posterInput.slug"
          />
          <ErrorMessage errorType="slug" :errorMessages="allErrors"></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>
          <b-form-checkbox
            v-model="posterInput.status"
            :aria-describedby="ariaDescribedby"
            value="active"
            @input="removeErrors('status')"
            >فعال</b-form-checkbox
          >
          <b-form-checkbox
            v-model="posterInput.status"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            @input="removeErrors('status')"
            >پیش نویس</b-form-checkbox
          >
          <ErrorMessage errorType="status" :errorMessages="allErrors"></ErrorMessage>
        </b-form-group>
        <b-form-group label="نمایش در :" v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group
            id="checkbox-group-2"
            v-model="posterInput.categories"
            :aria-describedby="ariaDescribedby"
            name="flavour-2"
            @input="removeErrors('categories')"
          >
            <b-form-checkbox :value="1"
              >صفحه اصلی</b-form-checkbox
            >
            <b-form-checkbox :value="2"
              >صفحه شهر</b-form-checkbox
            >
            <b-form-checkbox :value="3"
              >صفحه اقامتگاه</b-form-checkbox
            >
          </b-form-checkbox-group>
          <ErrorMessage errorType="categories" :errorMessages="allErrors"></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="desktop_image" class="text-capitalize"
            >desktop آپلود تصویر (600*1500):
          </label>
          <FilePicker
            @inputFile="inputDesktopImageFile"
            :url="desktopImageUrl"
            ref="desktopFilePicker"
          ></FilePicker>
          <ErrorMessage errorType="desktop_image" :errorMessages="allErrors"></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="desktop_mobile" class="text-capitalize"
            >Mobile آپلود تصویر (600*1500):
          </label>
          <FilePicker
            @inputFile="inputMobileImageFile"
            :url="mobileImageUrl"
            ref="mobileFilePicker"
          ></FilePicker>
          <ErrorMessage errorType="desktop_mobile" :errorMessages="allErrors"></ErrorMessage>
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal2 = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button
            variant="primary"
            @click="submitForm()"
            :disabled="
              posterInput.name == '' &&
              posterInput.url == '' &&
              posterInput.desktop_image == null &&
              posterInput.desktop_mobile == null
            "
          >
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormInvalidFeedback,
  BFormRadio,
  BFormCheckbox,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import FilePicker from "@/components/FilePicker.vue";
import ErrorMessage from "@/components/ErrorMessage.vue"

export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInvalidFeedback,
    BFormInput,
    BFormFile,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    BFormCheckbox,
    BFormCheckboxGroup,
    FilePicker,
    ErrorMessage
  },
  data() {
    return {
      errorMessage: {},
      showGettingCityLoading: false,
      mobileImageUrl: "",
      desktopImageUrl: "",
      categories: [],
      perPage: 10,
      page: 1,
      provinces: [],
      cities: [],
      posters: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      posterInput: {
        city_id: "",
        name: "",
        slug: "",
        url: "",
        status: "",
        categories: [],
        desktop_image: null,
        desktop_mobile: null,
      },
      tableHeadings: [
        {
          title: "عکس",
        },
        {
          title: "لینک",
          slug: "link",
          sortable: true,
        },
        {
          title: "عنوان",
          slug: "title",
          sortable: true,
        },
        {
          title: "تاریخ انتشار",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "بخش مربوطه",
          slug: "poster",
          sortable: true,
        },
        {
          title: "نوع",
          slug: "poster",
          sortable: true,
        },
        {
          title: "وضعیت",
          slug: "deleted_at",
          sortable: true,
        },
        {
          title: "ابزارها",
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      provincesCancelToken: undefined,
      posterInput: {
        id: "",
        province_id: "",
        name: "",
      },
      editMode: false,
      formModal: false,
      formModal2: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getPosters();
    this.getProvinces();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getPosters();
    },
    perPage(value) {
      this.page = 1;
      this.getPosters();
    },
    page(value) {
      this.getPosters();
    },
    
  },
  computed:{
    allErrors(){
      return this.errorMessage
    }
  },
  methods: {
    removeErrors(data){
      
      if(typeof this.errorMessage[data] !== 'undefined' && this.errorMessage[data].length>0){
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data]
        this.errorMessage = Object.assign({}, this.errorMessage, this.errorMessage)
        console.log(data,this.errorMessage)
      }
    },
    getProvinces(search, loading) {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
       // paginate: false,
        //  this.searchInput,
         per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/states",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.provinces = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    inputDesktopImageFile(file) {
      this.removeErrors('desktop_image')
      this.posterInput.desktop_image = file;
    },
    inputMobileImageFile(file) {
      this.removeErrors('desktop_mobile')
      this.posterInput.desktop_mobile = file;
    },
    getSelectedProvincesCity(provinceId) {
      this.removeErrors('state')
      this.showGettingCityLoading = true;
      this.getCityByProvinceId(provinceId);
    },
    async getCityByProvinceId(provinceId) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/cities/${provinceId}`,
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.cities = data.data;
          this.paginationData = data.meta;
          this.showGettingCityLoading = false;
          this.posterInput.city_id = this.cities[0]["id"];
        })
        .catch((err) => {
          console.log(err);
          this.showGettingCityLoading = false;
        });
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getPosters();
    },
    //_________________________________________________________________________
    async getPosters(THIS = this) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
        // host: window.location.href.replace('3000', '8080').replace('8081', '8080'),
      };

      const requestData = {
        method: "get",
        url: "/admin/posters",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          console.log(response.data.data);
          THIS.posters = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //_____________________________________________________________________________
    showConfirmModal(poster) {
      this.$bvModal
        .msgBoxConfirm(`آیا از حذف پوستر مطمئن هستید ؟  : ${poster.name}.`, {
          title: this.$t("Please Confirm"),
          size: "sm",
          okVariant: "primary",
          okTitle: this.$t("Yes"),
          cancelTitle: this.$t("No"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (confirmed) => {
          if (confirmed) {
            let posterIndex = 0;
            this.posters = await this.posters.filter((posterItem, index) => {
              if (posterItem.id == poster.id) {
                posterIndex = index;
              }
              return posterItem.id !== poster.id;
            });

            const requestData = {
              method: "delete",
              url: `/admin/posters/${poster.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(`${poster.name} با موفقیت حذف شد.`, {
                  title: this.$t("Done"),
                  variant: "success",
                  solid: true,
                });
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.posters.splice(posterIndex, 0, poster);
              });
          }
        });
    },
    //__________________________________________________________________________________
    showFormModal2(poster) {
      if (poster) {
        this.posterInput = {
          id: poster.id,
          state_id: poster.state.id,
          name: poster.name,

          city_id: poster.city.id,
          slug: poster.slug,
          url: poster.url,
          status: poster.status,
          categories: poster.categories,
          desktop_image: null,
          desktop_mobile: null,
        };
         this.$refs.desktopFilePicker.clearFileInput()
          this.$refs.mobileFilePicker.clearFileInput()
        this.mobileImageUrl = poster.desktop_mobile.path;
        this.desktopImageUrl = poster.desktop_image.path;
        this.getCityByProvinceId(poster.state.id);
        this.editMode = true;
      } else {
        this.posterInput = {
          id: "",
          state_id: "",
          name: "",

          city_id: "",
          slug: "",
          url: "",
          status: "",
          categories: [],
          desktop_image: null,
          desktop_mobile: null,
        };
         this.$refs.desktopFilePicker.clearFileInput()
          this.$refs.mobileFilePicker.clearFileInput()
           this.mobileImageUrl = "";
        this.desktopImageUrl = "";
        this.editMode = false;
      }
      this.formModal2 = true;
    },

    //________________________________________________________________
    submitForm() {
      this.submitLoading = true;
      let formData = new FormData();
      if (this.posterInput.city_id) {
        formData.append("city_id", this.posterInput.city_id);
      }
      if (this.posterInput.name) {
        formData.append("name", this.posterInput.name);
      }
      if (this.posterInput.slug) {
        formData.append("slug", this.posterInput.slug);
      }
      if (this.posterInput.status) {
        formData.append("status", this.posterInput.status);
      }
      if (this.posterInput.desktop_image) {
        formData.append("desktop_image", this.posterInput.desktop_image);
      }
      if (this.posterInput.desktop_mobile) {
        formData.append("desktop_mobile", this.posterInput.desktop_mobile);
      }
      if (this.posterInput.url) {
        formData.append("url", this.posterInput.url);
      }
      if (this.posterInput.categories.length > 0) {
        this.posterInput.categories.forEach((category, index) => {
          formData.append(`categories[${index}]`, category);
        });
      }
      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
          ? `/admin/posters/update/${this.posterInput.id}`
          : `/admin/posters`,
        data: formData,
      };

      this.$http(requestData)
        .then((response) => {
          // this.uploadFile("desktop_imageposter", "d_" + response.data.data);
          // this.uploadFile("desktop_mobileposter", "m_" + response.data.data);
          let message = "با موفقیت اضافه شد";
          if (this.editMode) message = "با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });
          if (!this.editMode) {
            this.page = 1;
            this.searchInput = "";
            this.sortBy = "";
            this.sortDir = "";
          }
          this.getPosters();
          this.submitLoading = false;
          this.formModal2 = false;
        })
        .catch((err) => {
          console.log(err.response);
          let message = "خطا در ایجاد";
          if (this.editMode) message = "خطا در ویرایش";
          if (
            err.response &&
            err.response.data &&
            err.response.data.response &&
            err.response.data.response.message
          )
            message = err.response.data.response.message;
          if (
            err.response &&
            err.response.data &&
            err.response.data.response &&
            err.response.data.response.meta &&
            err.response.data.response.meta.errors
          )
            this.errorMessage = err.response.data.response.meta.errors;
          console.log("this.errorMessage", this.errorMessage);
          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
      // this.uploadFile("desktop_imageposter", "d_");
    },
    //________________________________________________________________
    async uploadFile(idInput = "", imgName = "", THIS = this) {
      var formData = new FormData();
      // formData.append("file", document.getElementById(id).files[0]);
      formData.append("file", document.getElementById(idInput).files[0]);
      formData.append("format", ["jpg", "jpeg"]);
      formData.append("idImg", imgName);
      var xhttp = new XMLHttpRequest();
      xhttp.open(
        "POST",
        window.location.origin.replace(":8081", ":8080") +
          "/api_RoomToor/ajaxfile.php",
        true
      );
      console.log(xhttp);
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          this.getVar = JSON.parse(this.responseText);
          if (this.getVar.response == 1) {
            THIS.submitLoading = false;
            THIS.formModal = false;
            THIS.getPosters();
          } else {
            // THIS.error(THIS, "فرمت فایل باید jpg باشد");
          }
        }
      };
      xhttp.send(formData);
      // setTimeout(function() {
      // 	THIS.$router.push(url);
      // }, 1000)
    },
    //________________________________________________________________
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
